import { AbstractControl } from '@angular/forms';
import { ContactType } from '../enums/contact-type.enum';

export const isPersonal = (formControl: AbstractControl) => formControl.value === ContactType.PERSONAL;
